import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { allExpanded, defaultStyles, JsonView } from "react-json-view-lite";

// components
import { AccordionStyled } from "./accordion";

//style
import "./sidebar-results.css";
import { PropertySection } from "./property-data";


export const TabSite = ({ selectedResult }) => {
  /* console.log(resultList,  'result list in sidebar') */
  return (
    <Box
      sx={{
       /*  padding: "16px", */
        /* overflowY: "auto", */
      }}
      className={"sidebar-results"}
    >
      <Typography>Site</Typography>
      {/* <PropertySection /> */}
    </Box>
  );
};
